import Vue from 'vue';
import Buefy from 'buefy';
import '../scss/main.scss';
import Components from './components/all';
import mountApplication from './scripts/mountApplication';

Vue.component('b-tabs', Buefy.Tabs);
Vue.component('b-tab-item', Buefy.TabItem);

Object.entries(Components).forEach(entry => {
    Vue.component(entry[0], entry[1]);
});

document.addEventListener("DOMContentLoaded", function () {
    mountApplication();
});



// WEBPACK FOOTER //
// ./admin/src/js/index.js